import api from './api';

const ProjectService = {
  // Public Endpoints
  getAllProjects: (params) => {
    return api.get('/projects', { params });
  },
  
  getProjectById: (id) => {
    return api.get(`/projects/${id}`);
  },
  
  getProjectFilters: () => {
    return api.get('/projects/filters');
  },

  // OTP Verification Endpoints
  sendOtp: (data) => {
    return api.post('/otp/send', data);
  },

  verifyOtp: (data) => {
    return api.post('/otp/verify', data);
  },
  // Direct order submit (kept for backward compat; OTP flow uses verifyOtp instead)
  submitProjectOrder: (orderData) => {
    return api.post('/project-orders', orderData);
  },
  

  getPublicOrder: (id) => {
    return api.get(`/project-orders/public/${id}`);
  },

  // Admin Endpoints - Projects
  adminCreateProject: async (formData) => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${api.defaults.baseURL}/projects`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      },
      body: formData
    });
    const data = await response.json();
    if (!response.ok || !data.status) throw new Error(data.message || 'Upload failed');
    return { data };
  },
  
  adminUpdateProject: async (id, formData) => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${api.defaults.baseURL}/projects/${id}`, {
      method: 'POST', // Use POST for updating files with _method=PUT later if needed
      headers: {
        'Authorization': `Bearer ${token}`
      },
      body: formData
    });
    const data = await response.json();
    if (!response.ok || !data.status) throw new Error(data.message || 'Upload failed');
    return { data };
  },
  
  adminDeleteProject: (id) => {
    return api.delete(`/projects/${id}`);
  },

  adminCreateCategory: (data) => {
    return api.post('/projects/categories', data);
  },

  adminCreateLanguage: (data) => {
    return api.post('/projects/languages', data);
  },

  adminDeleteCategory: (id) => {
    return api.delete(`/projects/categories/${id}`);
  },

  adminDeleteLanguage: (id) => {
    return api.delete(`/projects/languages/${id}`);
  },

  // Admin Endpoints - Orders
  adminGetAllOrders: (params) => {
    return api.get('/project-orders', { params });
  },

  adminUpdateOrderStatus: (id, status, extraData = {}) => {
    return api.put(`/project-orders/${id}`, { status, ...extraData });
  },

  adminDeleteOrder: (id) => {
    return api.delete(`/project-orders/${id}`);
  }
};

export default ProjectService;
